export default {
	// things that only admins can do that don't fit super cleanly into the other categories
	adminUpdateSpaceInfo({dispatch, rootGetters}, data){
		return dispatch('request', {
			url: '/area-management/area/info',
			method: 'PUT',
			data: {
				...data,
				areaId: rootGetters.getCurrentAreaData.id
			}
		})
	},
	adminUpdateSpace({dispatch}, data){
		return dispatch('request', {
			url: '/area-management/area',
			method: 'PUT',
			data: data
		})
	},
	adminUpdateSpaceCustomisation({dispatch, rootGetters}, data){
		return dispatch('request', {
			url: '/area-management/area/customise',
			method: 'PUT',
			data: {
				...data,
				areaId: rootGetters.getCurrentAreaData.id
			}
		})
	},
	adminRemoveUsersFromSpace({dispatch, rootGetters}, users){
		return dispatch('request', {
			url: '/area-management/area/users',
			method: 'DELETE',
			data: {
				areaId: rootGetters.getCurrentAreaData.id,
				users
			}
		});
	},
	adminSetUserAdmin({dispatch, rootGetters}, [userId, admin]){
		return dispatch('request', {
			url: '/area-management/area/users/toggle-admin',
			method: 'POST',
			data: {
				areaId: rootGetters.getCurrentAreaData.id,
				userId,
				admin
			}
		});
	},
	adminBroadcast({dispatch, rootGetters}, [title, message]){
		return dispatch('request', {
			url: '/area-management/notifications/broadcast',
			method: 'POST',
			data: {
				areaId: rootGetters.getCurrentAreaData.id,
				title,
				message
			}
		});
	},
	adminRemoveBroadcast({dispatch, rootGetters}, notificationId){
		return dispatch('request', {
			url: `/area-management/notifications/${rootGetters.getCurrentAreaId}/broadcast/${notificationId}`,
			method: 'DELETE'
		});
	},
	adminGetUsers({dispatch, rootGetters}, [query, sortField, sortDescending, currentPage, pageSize, filters]){
		if(!rootGetters.getCurrentAreaData.id) return console.log('no area id')
		return dispatch('request', {
			url: `/area-management/invites/`+rootGetters.getCurrentAreaData.id,
			method: 'get',
			params: {
				query, sortField, sortDescending, currentPage, pageSize, filters
			}
		})
	},
}
